export enum PaymentType {
    REGULAR = 10,
    UTILITY = 20,
    GYMNET = 60
};
